/* istanbul ignore file */

import animationManager, {
  AnimationStatusCallbacks,
  makeSequence,
  SequenceStep,
} from "../../../../../../shared/services/animation-manager";
import { AnimationSequences } from "../../../../../../shared/utility/constants";

export default function registerOpenSingleDrawerAnimation({
  onAnimationStarts,
  onAnimationEnds,
}: Required<AnimationStatusCallbacks>): void {
  const sequence: SequenceStep[] = [
    [
      {
        onStart: onAnimationStarts,
        elementSelector: "phn-nd-single-drawer",
        animation: {
          className: "translate-in-from-left",
          cleanUpAfterAnimation: (element) => {
            element.style.translate = "0px";
          },
        },
      },
      {
        elementSelector: "phn-nd-backdrop",
        animation: {
          className: "fade-in-animation",
          cleanUpAfterAnimation: (element) => {
            element.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
            element.style.opacity = "1";
          },
        },
        onEnd: onAnimationEnds,
      },
    ],
  ];

  animationManager.register(
    AnimationSequences.OPEN_SINGLE_DRAWER,
    makeSequence(sequence),
  );
}
